exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-grid-tile {\n  cursor: pointer; }\n  mat-grid-tile .content {\n    border: 1px solid #fff; }\n    mat-grid-tile .content:hover, mat-grid-tile .content.active {\n      background-color: #222; }\n    mat-grid-tile .content img {\n      height: 150px;\n      width: 200px;\n      -o-object-fit: cover;\n         object-fit: cover; }\n    mat-grid-tile .content h1 {\n      text-align: center;\n      padding: 10px;\n      text-transform: uppercase; }\n\nmat-expansion-panel {\n  background-color: #353535; }\n  mat-expansion-panel mat-panel-title {\n    text-transform: uppercase;\n    font-size: 18px;\n    text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/sitemodel/sitemodel.component.scss
// module id = ../../../../../src/app/components/sitemodel/sitemodel.component.scss
// module chunks = main